/* ============================================================
   PSIABUDA SHOPIFY THEME - JavaScript
   ============================================================ */

(function() {
  'use strict';

  /**
   * Zdejmuje „przygaszenie” strony: backdrop menu mobilnego, overflow na body itd.
   * Pomaga gdy po błędzie koszyka (np. brak stanu) zostaje aktywna nakładka.
   */
  window.psiabudaResetOverlays = function() {
    try {
      document.querySelectorAll('.mobile-menu__backdrop').forEach(function(el) {
        el.classList.remove('is-open');
      });
      document.querySelectorAll('[data-mobile-menu]').forEach(function(el) {
        el.classList.remove('is-open');
      });
      document.querySelectorAll('[data-search-overlay]').forEach(function(el) {
        el.classList.remove('is-open');
      });
      document.body.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('overflow');
    } catch (e) { /* ignore */ }
  };

  if (document.body && document.body.classList.contains('template-cart')) {
    window.psiabudaResetOverlays();
  }

  window.addEventListener('pageshow', function(ev) {
    if (ev.persisted) window.psiabudaResetOverlays();
  });

  /* ---------- Mobile Menu ---------- */
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileBackdrop = document.querySelector('[data-mobile-menu-backdrop]');

  function openMobileMenu() {
    if (mobileMenu) mobileMenu.classList.add('is-open');
    if (mobileBackdrop) mobileBackdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (mobileMenu) mobileMenu.classList.remove('is-open');
    if (mobileBackdrop) mobileBackdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (mobileMenuToggle) mobileMenuToggle.addEventListener('click', openMobileMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);
  if (mobileBackdrop) mobileBackdrop.addEventListener('click', closeMobileMenu);

  document.querySelectorAll('[data-submenu-toggle]').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var submenu = this.nextElementSibling;
      this.classList.toggle('is-open');
      if (submenu) submenu.classList.toggle('is-open');
    });
  });

  /* ---------- Search Toggle ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchClose = document.querySelector('[data-search-close]');

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function() {
      searchOverlay.classList.toggle('is-open');
      if (searchOverlay.classList.contains('is-open')) {
        searchOverlay.querySelector('input').focus();
      }
    });
  }

  if (searchClose && searchOverlay) {
    searchClose.addEventListener('click', function() {
      searchOverlay.classList.remove('is-open');
    });
  }

  /* ---------- Slideshow ---------- */
  var slideshow = document.querySelector('[data-slideshow]');

  if (slideshow) {
    var track = slideshow.querySelector('[data-slideshow-track]');
    var slides = slideshow.querySelectorAll('.slideshow__slide');
    var dots = slideshow.querySelectorAll('[data-slideshow-dot]');
    var prevBtn = slideshow.querySelector('[data-slideshow-prev]');
    var nextBtn = slideshow.querySelector('[data-slideshow-next]');
    var currentSlide = 0;
    var totalSlides = slides.length;
    var autoplayTimer = null;

    var names = document.querySelectorAll('[data-slideshow-name]');

    function goToSlide(index) {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      currentSlide = index;

      track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';

      slides.forEach(function(s) { s.classList.remove('is-active'); });
      slides[currentSlide].classList.add('is-active');

      dots.forEach(function(d) { d.classList.remove('is-active'); });
      if (dots[currentSlide]) dots[currentSlide].classList.add('is-active');

      names.forEach(function(n) { n.classList.remove('is-active'); });
      if (names[currentSlide]) names[currentSlide].classList.add('is-active');
    }

    function nextSlide() { goToSlide(currentSlide + 1); }
    function prevSlide() { goToSlide(currentSlide - 1); }

    if (prevBtn) prevBtn.addEventListener('click', function() { prevSlide(); resetAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { nextSlide(); resetAutoplay(); });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToSlide(parseInt(this.dataset.slideshowDot));
        resetAutoplay();
      });
    });

    names.forEach(function(name) {
      name.addEventListener('click', function() {
        goToSlide(parseInt(this.dataset.slideshowName));
        resetAutoplay();
      });
    });

    function startAutoplay() {
      autoplayTimer = setInterval(nextSlide, 5000);
    }

    function resetAutoplay() {
      clearInterval(autoplayTimer);
      startAutoplay();
    }

    if (totalSlides > 1) startAutoplay();

    slideshow.addEventListener('mouseenter', function() { clearInterval(autoplayTimer); });
    slideshow.addEventListener('mouseleave', function() { if (totalSlides > 1) startAutoplay(); });
  }

  /* ---------- Quantity Buttons ----------
     Strona produktu ma własną obsługę (z limitem stanu magazynowego)
     w templates/product.liquid — pomijamy ją tutaj, żeby nie podpinać
     dwóch handlerów do tych samych przycisków (zmiana o 2 zamiast o 1). */
  document.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
    if (btn.closest('.product-page')) return;
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('input[type="number"]');
      var val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
  });

  document.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
    if (btn.closest('.product-page')) return;
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('input[type="number"]');
      var val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  });

  /* ---------- Product Gallery: obsługa w templates/product.liquid (warstwy obrazów) ---------- */

  /* ---------- Sort Select (Collection Page) ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });

    var params = new URLSearchParams(window.location.search);
    if (params.has('sort_by')) {
      sortSelect.value = params.get('sort_by');
    }
  }

  /* ---------- AJAX Add to Cart (karty produktów — delegacja, działa też po dodaniu kart z JS) ---------- */
  document.body.addEventListener('submit', function(e) {
    var form = e.target.closest('.product-card__add-form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    var formData = new FormData(form);
    var originalHTML = btn.innerHTML;

    btn.disabled = true;
    btn.innerHTML = '<i class="fa-solid fa-check"></i> Dodano!';

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(function(res) {
        return res.json().then(function(data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function(result) {
        if (!result.ok) {
          window.psiabudaResetOverlays();
          btn.disabled = false;
          var msg = (result.data && (result.data.description || result.data.message)) || 'Nie udało się dodać produktu.';
          if (msg.length > 120) msg = msg.slice(0, 117) + '…';
          btn.innerHTML = '<i class="fa-solid fa-exclamation-triangle"></i> ' + msg;
          btn.style.background = '#c0392b';
          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.style.background = '';
          }, 4000);
          return;
        }
        updateCartCount();
        openCartDrawer(result.data.product_id);
        setTimeout(function() {
          btn.disabled = false;
          btn.innerHTML = originalHTML;
        }, 1500);
      })
      .catch(function() {
        window.psiabudaResetOverlays();
        btn.disabled = false;
        btn.innerHTML = '<i class="fa-solid fa-exclamation-triangle"></i> Błąd';
        setTimeout(function() { btn.innerHTML = originalHTML; }, 2000);
      });
  });

  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = document.getElementById('add-to-cart-btn');
      if (!btn) return;
      var formData = new FormData(this);
      var originalHTML = btn.innerHTML;

      btn.disabled = true;
      btn.innerHTML = '<i class="fa-solid fa-check"></i> Dodano do koszyka!';
      btn.style.background = '#2e7d32';

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(res) {
        return res.json().then(function(data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function(result) {
        if (!result.ok) {
          window.psiabudaResetOverlays();
          btn.disabled = false;
          var msg = (result.data && (result.data.description || result.data.message)) || 'Nie udało się dodać do koszyka.';
          if (msg.length > 120) msg = msg.slice(0, 117) + '…';
          btn.innerHTML = '<i class="fa-solid fa-exclamation-triangle"></i> ' + msg;
          btn.style.background = '#c0392b';
          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.style.background = '';
          }, 4000);
          return;
        }
        updateCartCount();
        openCartDrawer(result.data.product_id);
        setTimeout(function() {
          btn.disabled = false;
          btn.innerHTML = originalHTML;
          btn.style.background = '';
        }, 2000);
      })
      .catch(function() {
        window.psiabudaResetOverlays();
        btn.disabled = false;
        btn.innerHTML = '<i class="fa-solid fa-exclamation-triangle"></i> Wystąpił błąd';
        btn.style.background = '#c0392b';
        setTimeout(function() {
          btn.innerHTML = originalHTML;
          btn.style.background = '';
        }, 2000);
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      });
  }

  /* ---------- Cart Drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartDrawerBackdrop = document.querySelector('[data-cart-drawer-backdrop]');
  var _lastUpsellProductId = null;

  function openCartDrawer(lastProductId) {
    if (!cartDrawer) return;
    if (lastProductId) _lastUpsellProductId = lastProductId;
    renderCartDrawer();
    cartDrawer.classList.add('is-open');
    if (cartDrawerBackdrop) cartDrawerBackdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  window.openCartDrawer = openCartDrawer;

  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartDrawerBackdrop) cartDrawerBackdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartDrawerBackdrop) cartDrawerBackdrop.addEventListener('click', closeCartDrawer);
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function(btn) {
    btn.addEventListener('click', closeCartDrawer);
  });

  /* Cart icon in header → open drawer instead of navigating */
  document.querySelectorAll('[data-cart-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  /* Close drawer on Escape */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) {
      closeCartDrawer();
    }
  });

  /* Free shipping progress bar */
  function renderShippingBar(cart) {
    var bar = document.querySelector('[data-shipping-bar]');
    if (!bar) return;
    if (!cartDrawer) return;
    var enabled = (cartDrawer.getAttribute('data-free-shipping-enabled') || '').toLowerCase() === 'true';
    if (!enabled) {
      bar.style.display = 'none';
      return;
    }
    var threshold = parseInt(cartDrawer.getAttribute('data-free-shipping-threshold'), 10) || 0;
    if (threshold <= 0) {
      bar.style.display = 'none';
      return;
    }
    if (!cart.items || cart.items.length === 0) {
      bar.style.display = 'none';
      return;
    }
    bar.style.display = '';
    var total = cart.total_price || 0;
    var text = bar.querySelector('[data-shipping-text]');
    var fill = bar.querySelector('[data-shipping-fill]');
    var pct = Math.min(100, Math.round(total / threshold * 100));
    if (fill) {
      fill.style.width = pct + '%';
      fill.classList.toggle('is-complete', total >= threshold);
    }
    if (text) {
      if (total >= threshold) {
        text.className = 'cart-drawer__shipping-text cart-drawer__shipping-text--free';
        text.innerHTML = '<i class="fa-solid fa-circle-check"></i> Gratulacje! Masz <strong>darmową dostawę</strong> 🎉';
      } else {
        var remaining = threshold - total;
        var remStr = (remaining / 100).toFixed(2).replace('.', ',') + ' zł';
        text.className = 'cart-drawer__shipping-text';
        text.innerHTML = '<i class="fa-solid fa-truck-fast"></i> Do <strong>darmowej dostawy</strong> brakuje Ci <strong>' + remStr + '</strong>';
      }
    }
  }

  /* Note: toggle visibility + debounced save */
  var _noteSaveTimer = null;
  var _noteLastSaved = '';
  function attachNoteHandlers() {
    var wrap = document.querySelector('[data-cart-note]');
    if (!wrap || wrap.dataset.noteBound === '1') return;
    wrap.dataset.noteBound = '1';
    var toggle = wrap.querySelector('[data-note-toggle]');
    var input = wrap.querySelector('[data-cart-note-input]');
    var status = wrap.querySelector('[data-note-status]');

    if (toggle) {
      toggle.addEventListener('click', function() {
        var open = wrap.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && input) setTimeout(function() { input.focus(); }, 250);
      });
    }
    if (input) {
      _noteLastSaved = input.value || '';
      if (_noteLastSaved.trim().length > 0) {
        wrap.classList.add('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      }
      input.addEventListener('input', function() {
        var val = input.value;
        if (status) { status.textContent = 'Zapisywanie…'; status.classList.remove('is-saved'); }
        clearTimeout(_noteSaveTimer);
        _noteSaveTimer = setTimeout(function() {
          if (val === _noteLastSaved) return;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: val })
          }).then(function() {
            _noteLastSaved = val;
            if (status) {
              status.textContent = '✓ Zapisano';
              status.classList.add('is-saved');
              setTimeout(function() { if (status.textContent === '✓ Zapisano') status.textContent = ''; }, 1800);
            }
          }).catch(function() {
            if (status) status.textContent = 'Błąd zapisu';
          });
        }, 600);
      });
    }
  }

  /* Terms checkbox: enable/disable checkout */
  function attachTermsHandlers() {
    var wrap = document.querySelector('[data-terms-wrap]');
    var checkbox = document.querySelector('[data-terms-checkbox]');
    var checkoutBtn = document.querySelector('[data-cart-checkout]');
    if (!checkoutBtn) return;
    if (cartDrawer.getAttribute('data-require-terms') !== 'true') {
      checkoutBtn.disabled = false;
    } else if (checkbox && wrap && !wrap.dataset.termsBound) {
      wrap.dataset.termsBound = '1';
      checkbox.addEventListener('change', function() {
        wrap.classList.toggle('is-checked', checkbox.checked);
        wrap.classList.remove('is-error');
        checkoutBtn.disabled = !checkbox.checked;
      });
    }
    if (checkoutBtn.dataset.checkoutBound !== '1') {
      checkoutBtn.dataset.checkoutBound = '1';
      checkoutBtn.addEventListener('click', function(e) {
        if (cartDrawer.getAttribute('data-require-terms') === 'true') {
          if (!checkbox || !checkbox.checked) {
            e.preventDefault();
            if (wrap) {
              wrap.classList.add('is-error');
              wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
              setTimeout(function() { wrap.classList.remove('is-error'); }, 1200);
            }
            return;
          }
        }
        checkoutBtn.disabled = true;
        var label = checkoutBtn.querySelector('span');
        if (label) label.textContent = 'Przekierowuję…';
        var icon = checkoutBtn.querySelector('i');
        if (icon) icon.className = 'fa-solid fa-spinner fa-spin';
        /* Make sure note is saved before checkout */
        var noteInput = document.querySelector('[data-cart-note-input]');
        var notePayload = noteInput ? { note: noteInput.value } : null;
        var save = notePayload && notePayload.note !== _noteLastSaved
          ? fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(notePayload)
            })
          : Promise.resolve();
        save.finally(function() { window.location.href = '/checkout'; });
      });
    }
  }

  function renderCartDrawer() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var itemsEl = document.querySelector('[data-cart-drawer-items]');
        var subtotalEl = document.querySelector('[data-cart-drawer-subtotal]');
        var countEl = document.querySelector('[data-cart-drawer-count]');
        var emptyEl = document.querySelector('[data-cart-drawer-empty]');
        var footerEl = document.querySelector('[data-cart-drawer-footer]');
        if (!itemsEl) return;

        if (countEl) countEl.textContent = cart.item_count;

        if (cart.items.length === 0) {
          itemsEl.innerHTML = '';
          if (emptyEl) emptyEl.style.display = '';
          if (footerEl) footerEl.style.display = 'none';
          var upsellEl = document.querySelector('[data-cart-drawer-upsell]');
          if (upsellEl) upsellEl.innerHTML = '';
          var shipBar = document.querySelector('[data-shipping-bar]');
          if (shipBar) shipBar.style.display = 'none';
          return;
        }
        if (emptyEl) emptyEl.style.display = 'none';
        if (footerEl) footerEl.style.display = '';

        var html = '';
        cart.items.forEach(function(item) {
          var priceFormatted = (item.final_line_price / 100).toFixed(2).replace('.', ',') + ' zł';
          var img = item.image ? item.image.replace(/(\.[^.]+)$/, '_160x160$1') : '';
          html += '<div class="cart-drawer__item" data-line-key="' + item.key + '">';
          html += '<img src="' + img + '" alt="" class="cart-drawer__item-img" width="68" height="68">';
          html += '<div class="cart-drawer__item-info">';
          html += '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>';
          if (item.variant_title) html += '<span class="cart-drawer__item-variant">' + item.variant_title + '</span>';
          html += '<div class="cart-drawer__item-qty">';
          html += '<button type="button" class="cart-drawer__qty-btn" data-drawer-qty-minus="' + item.key + '" aria-label="Zmniejsz">−</button>';
          html += '<span class="cart-drawer__qty-val">' + item.quantity + '</span>';
          html += '<button type="button" class="cart-drawer__qty-btn" data-drawer-qty-plus="' + item.key + '" aria-label="Zwiększ">+</button>';
          html += '</div>';
          html += '</div>';
          html += '<div class="cart-drawer__item-right">';
          html += '<span class="cart-drawer__item-price">' + priceFormatted + '</span>';
          html += '<button type="button" class="cart-drawer__item-remove" data-drawer-remove="' + item.key + '" aria-label="Usuń"><i class="fa-solid fa-trash-can"></i></button>';
          html += '</div>';
          html += '</div>';
        });
        itemsEl.innerHTML = html;

        if (subtotalEl) {
          subtotalEl.textContent = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' zł';
        }

        renderShippingBar(cart);
        attachNoteHandlers();
        attachTermsHandlers();
        renderDrawerUpsell(cart);
      });
  }

  function upsellProductImageUrl(p) {
    var src = '';
    if (p.featured_image) {
      src = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || p.featured_image.url || '');
    }
    if (!src && p.images && p.images[0]) {
      src = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || p.images[0].url || '');
    }
    if (!src && p.image) {
      src = typeof p.image === 'string' ? p.image : (p.image.src || p.image.url || '');
    }
    if (!src && p.media && p.media[0] && p.media[0].preview_image) {
      src = p.media[0].preview_image.src || p.media[0].preview_image.url || '';
    }
    if (!src) return '';
    src = src.split('?')[0];
    return src.replace(/(\.[a-zA-Z]{3,4})$/, '_small$1');
  }

  function upsellExtractPrice(product, field) {
    var raw = product[field];
    if (raw != null && raw !== '' && raw !== 0) return raw;
    if (product.variants && product.variants[0]) {
      var v = product.variants[0];
      if (field === 'price' && v.price != null && v.price !== '') return v.price;
      if (field === 'compare_at_price' && v.compare_at_price != null && v.compare_at_price !== '') return v.compare_at_price;
    }
    if (field === 'price' && product.price_min != null) return product.price_min;
    return null;
  }

  function upsellParsePrice(raw) {
    if (raw == null || raw === '') return null;
    var s = String(raw).replace(/\s/g, '').replace(',', '.');
    var n = parseFloat(s);
    if (isNaN(n) || n === 0) return null;
    if (typeof raw === 'string' && s.indexOf('.') !== -1) return n;
    if (Number.isInteger(n) && n >= 100) return n / 100;
    return n;
  }

  function upsellFormatPrice(val) {
    if (val == null) return '';
    return val.toFixed(2).replace('.', ',') + ' zł';
  }

  function renderDrawerUpsell(cart) {
    var upsellEl = document.querySelector('[data-cart-drawer-upsell]');
    if (!upsellEl) return;

    var cartIds = (cart.items || []).map(function(i) { return Number(i.product_id); });
    function notInCart(p) {
      if (!p || p.id == null) return false;
      return cartIds.indexOf(Number(p.id)) === -1;
    }
    function uniqProducts(arr) {
      var seen = Object.create(null);
      var out = [];
      arr.forEach(function(p) {
        if (!p || p.id == null) return;
        var id = Number(p.id);
        if (seen[id]) return;
        seen[id] = true;
        out.push(p);
      });
      return out;
    }
    function takeOne(list) {
      return uniqProducts(list.filter(notInCart)).slice(0, 1);
    }
    function fetchRec(productId) {
      if (!productId) return Promise.resolve([]);
      return fetch(
        '/recommendations/products.json?product_id=' +
          encodeURIComponent(productId) +
          '&limit=8&intent=related'
      )
        .then(function(r) {
          return r.ok ? r.json() : { products: [] };
        })
        .then(function(data) {
          return data.products || [];
        })
        .catch(function() {
          return [];
        });
    }
    function fetchCollectionFallback() {
      return fetch('/collections/all/products.json?limit=24')
        .then(function(r) {
          return r.ok ? r.json() : { products: [] };
        })
        .then(function(data) {
          return data.products || [];
        })
        .catch(function() {
          return [];
        });
    }

    var seed = null;
    if (_lastUpsellProductId != null) {
      seed = Number(_lastUpsellProductId);
    } else if (cart.items && cart.items[0]) {
      seed = Number(cart.items[0].product_id);
    }

    var recPromise =
      seed == null || isNaN(seed)
        ? Promise.resolve([])
        : fetchRec(seed);

    recPromise
      .then(function(recs) {
        var picked = takeOne(recs || []);
        if (picked.length) return picked;
        return fetchCollectionFallback().then(function(fb) {
          return takeOne((recs || []).concat(fb || []));
        });
      })
      .then(function(products) {
        if (!products.length) {
          upsellEl.innerHTML = '';
          return;
        }
        var p = products[0];
        var pImg = upsellProductImageUrl(p);
        var priceVal = upsellParsePrice(upsellExtractPrice(p, 'price'));
        var compareVal = upsellParsePrice(upsellExtractPrice(p, 'compare_at_price'));
        var pPrice = upsellFormatPrice(priceVal);
        var hasSale = compareVal && priceVal && compareVal > priceVal;
        var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';

        if (pImg) {
          var preload = new Image();
          preload.src = pImg;
        }

        var uhtml = '<div class="cart-drawer__upsell-single">';
        uhtml += '<span class="cart-drawer__upsell-label"><i class="fa-solid fa-wand-magic-sparkles"></i> Może Ci się spodobać</span>';
        uhtml += '<div class="cart-drawer__upsell-row">';
        uhtml += '<a href="' + p.url + '" class="cart-drawer__upsell-img-wrap">';
        uhtml += '<img src="' + pImg + '" alt="" class="cart-drawer__upsell-img" fetchpriority="high">';
        uhtml += '</a>';
        uhtml += '<div class="cart-drawer__upsell-info">';
        uhtml += '<a href="' + p.url + '" class="cart-drawer__upsell-name">' + p.title + '</a>';
        uhtml += '<div class="cart-drawer__upsell-price-row">';
        if (hasSale) {
          uhtml += '<span class="cart-drawer__upsell-price cart-drawer__upsell-price--sale">' + pPrice + '</span>';
          uhtml += '<span class="cart-drawer__upsell-compare">' + upsellFormatPrice(compareVal) + '</span>';
        } else if (pPrice) {
          uhtml += '<span class="cart-drawer__upsell-price">' + pPrice + '</span>';
        }
        uhtml += '</div>';
        uhtml += '</div>';
        uhtml += '<button type="button" class="cart-drawer__upsell-add" data-upsell-add="' + variantId + '"><i class="fa-solid fa-plus"></i></button>';
        uhtml += '</div></div>';
        upsellEl.innerHTML = uhtml;
      })
      .catch(function() {
        upsellEl.innerHTML = '';
      });
  }

  document.body.addEventListener('click', function(e) {
    var minusBtn = e.target.closest('[data-drawer-qty-minus]');
    var plusBtn = e.target.closest('[data-drawer-qty-plus]');
    var removeBtn = e.target.closest('[data-drawer-remove]');
    var upsellBtn = e.target.closest('[data-upsell-add]');

    if (minusBtn) {
      changeDrawerQty(minusBtn.getAttribute('data-drawer-qty-minus'), -1);
    } else if (plusBtn) {
      changeDrawerQty(plusBtn.getAttribute('data-drawer-qty-plus'), 1);
    } else if (removeBtn) {
      changeDrawerQty(removeBtn.getAttribute('data-drawer-remove'), 0);
    } else if (upsellBtn) {
      var vid = upsellBtn.getAttribute('data-upsell-add');
      if (!vid) return;
      upsellBtn.disabled = true;
      upsellBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i>';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        updateCartCount();
        renderCartDrawer();
      })
      .catch(function() {
        upsellBtn.innerHTML = '<i class="fa-solid fa-exclamation"></i>';
        setTimeout(function() { upsellBtn.innerHTML = '<i class="fa-solid fa-bag-shopping"></i> Dodaj'; upsellBtn.disabled = false; }, 2000);
      });
    }
  });

  function changeDrawerQty(key, delta) {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var item = cart.items.find(function(i) { return i.key === key; });
      if (!item) return;
      var newQty = delta === 0 ? 0 : item.quantity + delta;
      if (newQty < 0) newQty = 0;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      });
    }).then(function() {
      updateCartCount();
      renderCartDrawer();
    });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var WL_KEY = 'psiabuda_wishlist';

  function normalizeWishlist(list) {
    if (!Array.isArray(list)) return [];
    var seen = Object.create(null);
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var h = list[i];
      if (h == null || h === '') continue;
      h = String(h).trim();
      if (!h || seen[h]) continue;
      seen[h] = true;
      out.push(h);
    }
    return out;
  }

  function getWishlist() {
    try {
      var raw = JSON.parse(localStorage.getItem(WL_KEY) || '[]');
      var norm = normalizeWishlist(raw);
      if (JSON.stringify(norm) !== JSON.stringify(raw)) {
        localStorage.setItem(WL_KEY, JSON.stringify(norm));
      }
      return norm;
    } catch (e) {
      try { localStorage.removeItem(WL_KEY); } catch (e2) {}
      return [];
    }
  }
  function saveWishlist(list) {
    list = normalizeWishlist(list);
    localStorage.setItem(WL_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent('wishlist:changed'));
  }

  window.psiabudaWishlist = {
    key: WL_KEY,
    getList: getWishlist,
    saveList: saveWishlist,
    normalizeList: normalizeWishlist
  };

  function syncWishlistUI() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
      var handle = btn.getAttribute('data-wishlist-toggle');
      var inList = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-wishlisted', inList);
      var icon = btn.querySelector('i');
      if (icon) {
        icon.className = inList ? 'fa-solid fa-heart' : 'fa-regular fa-heart';
      }
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
      el.textContent = list.length;
      el.style.display = list.length > 0 ? '' : 'none';
    });
  }

  document.body.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = (btn.getAttribute('data-wishlist-toggle') || '').trim();
    if (!handle) return;
    var list = getWishlist().slice();
    var idx = list.indexOf(handle);
    if (idx === -1) { list.push(handle); } else { list.splice(idx, 1); }
    saveWishlist(list);
    syncWishlistUI();
  });

  window.addEventListener('wishlist:changed', syncWishlistUI);
  syncWishlistUI();

})();
